import styled from "styled-components/macro";
import { TextProps } from "../types";
import { getTextAlign } from "./helpers";
import { getCommonProps, collectTypographyStyles } from "../../../types";
import Icon from "../../Icon";
import { IndicatorStyles } from "..";
import { useLink } from "./useLink";

export const ButtonWrapper = styled.span<TextProps>`
    ${(props) => getTextAlign(props)};
    ${(props) => ({
        ...props.theme.typography.button,
        ...props.styles,
    })};
    ${(props) => getCommonProps(props)};
    ${(props) => collectTypographyStyles(props)};
    ${(props) => (props.color ? { color: props.color } : props.theme.colors.text.contrast)}
    ${(props) => (props.secondary ? { color: props.theme.colors.text.secondary } : {})};
    position: relative;
    transition: ${props => props.noTransition ? "none" : "all 200ms ease-in"};
`;

export default function Button (props: TextProps) {

    const { navigate } = useLink()

    return <ButtonWrapper {...props} onClick={props.onClick ?? navigate(props.link)}>
        {props.children}
        {props.withIndicator && <Icon name="color-indicator" styles={IndicatorStyles}/>}
    </ButtonWrapper>
}